import { defineRule, configure } from "vee-validate";
import { email } from "@vee-validate/rules";

defineRule("required", (value, _, context) => {
  if(!value) return `${context.label} is required`

  return true
});
defineRule("email", email);
defineRule("password", (value) => {
  if (!value) return "Password is required.";

  const greaterThanTwelveCheck = value.length >= 12;
  const upperCheck = /[A-Z]/.test(value);
  const lowerCheck = /[a-z]/.test(value);
  const numberCheck = /[0-9]/.test(value);
  const specialCheck = /[!@#$%^&*(),.?":{}|<>]/.test(value);

  if (!greaterThanTwelveCheck) return "Password must be at least 12 characters.";
  if (!upperCheck) return "Password must include at least one uppercase letter.";
  if (!lowerCheck) return "Password must include at least one lowercase letter.";
  if (!numberCheck) return "Password must include at least one number.";
  if (!specialCheck) return "Password must include at least one special character.";

  return true;
});
defineRule("confirmed", (value, [target], ctx) => {
  if (value === ctx.form[target]) {
    return true;
  }
  return `${ctx.field} does not match ${target}.`;
})

defineRule("ein", (value) => {
  if(/^\d{2}-?\d{7}$/.test(value)) {
    return true
  }
  return 'Invalid Employer Identification Number'
})

defineRule("ssn", (value) => {
  if(/^\d{3}-?\d{2}-?\d{4}$/.test(value)) {
    return true
  }
  return 'Invalid Social Security Number'
})

defineRule("website", (value) => {
  if(!value || /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-z]{2,}.*$/i.test(value)) {
    return true
  }
  return 'Invalid website url'
})

defineRule("linkedin", (value) => {
  if(!value || /^(https?:\/\/)?(www\.)?linkedin\.com\/.+$/i.test(value)) {
    return true
  }
  return 'Invalid linkedin profile url'
})

defineRule("instagram", (value) => {
  if(!value || /^(https?:\/\/)?(www\.)?instagram\.com\/.+$/i.test(value)) {
    return true
  }
  return 'Invalid instagram profile url'
})

defineRule("facebook", (value) => {
  if(!value || /^(https?:\/\/)?(www\.)?facebook\.com\/.+$/i.test(value)) {
    return true
  }
  return 'Invalid facebook profile url'
})

defineRule("url", (value) => {
  if(!value || /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-z]{2,}.*$/i.test(value)) {
    return true
  }
  return 'Invalid url'
})

defineRule("zip", (value) => {
  if(!value || /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value)) {
    return true
  }
  return 'Invalid zip'
})

configure({
  generateMessage: (ctx) => {
    const messages = {
      required: `${ctx.field} is required.`,
      confirmed: `${ctx.field} does not match.`,
      email: `Incorrect email`
    };

    return messages[ctx.rule.name] || `The ${ctx.field} field is invalid.`;
  },
});

export const formatEIN = (value) => {
  if (!value) return { raw: '', formatted: '' };
  const clean = value.replace(/\D/g, '').slice(0, 9);
  const formatted = clean.replace(/(\d{2})(\d{7})/, '$1-$2');
  return {
    raw: clean,
    formatted: formatted,
  };
}

export const formatSSN = (value) => {
  if (!value) return { raw: '', formatted: '' };
  const clean = value.replace(/\D/g, '').slice(0, 9);
  return {
    raw: clean,
    formatted: clean.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3')
  };
}
